import React from 'react';
import { render } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { ToggleSwitch } from './ToggleSwitch';

describe('ToggleSwitch', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	const user = userEvent.setup();

	it('it should be checked on click', async () => {
		const { getByLabelText } = render(<ToggleSwitch label="Label" />);
		const toggleSwitch = getByLabelText('Label') as HTMLInputElement;
		expect(toggleSwitch.checked).toEqual(false);
		await user.click(toggleSwitch);
		expect(toggleSwitch.checked).toEqual(true);
	});

	it('it should return object on change', async () => {
		const onChangeTest = jest.fn();
		const { getByLabelText } = render(
			<ToggleSwitch onChange={onChangeTest} value="test" label="Label" />
		);
		const toggleSwitch = getByLabelText('Label') as HTMLInputElement;
		await user.click(toggleSwitch);
		expect(onChangeTest).toBeCalledWith('test', true);
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<ToggleSwitch label="Label" data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
